<template>
  <div v-if="!hasPermission('Create Contract Template')">Você não tem permissão para acessar esta página!</div>
  <div v-else>
    <Toolbar />

    <div class="container-xxl">
    <div class="card">
      <div class="card-header">
        <div class="card-title">
          <div class="d-flex align-items-center position-relative my-1">
            <span class="svg-icon svg-icon-1 position-absolute ms-6">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1"
                      transform="rotate(45 17.0365 15.1223)" fill="black"></rect>
                <path
                  d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z"
                  fill="black"></path>
              </svg>
            </span>
            <input type="search" v-model="search"
                   class="form-control form-control-solid w-250px ps-14"
                   placeholder="Pesquisar...">
          </div>
        </div>
        <div class="card-toolbar">
          <button v-if="hasPermission('Create Contract Template')" class="btn btn-primary" @click="newTemplate">
            <i class="bi bi-plus-lg me-1"></i>
            Novo modelo
          </button>
        </div>
      </div>
      <div class="card-body py-4">
        <div class="table-responsive">
          <table class="table table-hover table-row-bordered">
            <thead>
            <tr class="fw-bold fs-6 text-muted">
              <th>Nome</th>
              <th>Criado por</th>
              <th>Ativo?</th>
              <th class="text-center">Ações</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="template in templates.data" :key="template.id_contract_template">
              <td>
                <span class="text-gray-800 text-hover-primary">{{ template.template_name }}</span>
              </td>
              <td>{{ template.created_by?.user_name || '-' }}</td>
              <td>
                <span :class="template.template_active ? 'badge badge-success' : 'badge badge-secondary'">
                  {{ template.template_active ? 'Sim' : 'Não' }}
                </span>
              </td>
              <td class="text-center" style="min-width: 100px;">
                <button class="btn btn-sm btn-icon btn-bg-light btn-active-color-primary me-1 border border-gray-400"
                        type="button" v-if="hasPermission('Update Contract Template')" @click="editTemplate(template)"
                        title="Editar modelo">
                  <i class="bi bi-pen"></i>
                </button>
                <button class="btn btn-sm btn-icon btn-bg-light btn-active-color-danger border border-gray-400"
                        type="button" v-if="hasPermission('Delete Contract Template')" @click="deleteTemplate(template)"
                        title="Remover modelo">
                  <i class="bi bi-trash2"></i>
                </button>
              </td>
            </tr>
            <tr v-if="!templates.data?.length">
              <td colspan="4" class="text-center text-muted py-5">
                Nenhum modelo de contrato encontrado.
              </td>
            </tr>
            </tbody>
          </table>

          <Pagination :data="templates"/>
        </div>
      </div>
    </div>

    <ContractTemplateModal
      :template="selectedTemplate"
      @onClose="selectedTemplate = null"
      @templateSaved="loadTemplates"
    />
  </div>
  </div>
</template>

<script>
import http from "../../helpers/http";
import Pagination from "../../components/Pagination";
import Toolbar from "../../components/layouts/auth/Toolbar.vue";
import ContractTemplateModal from "@/views/contract_template/ContractTemplateModal.vue";
import Modal from "@/helpers/modal";
import Alert from "@/helpers/alert";
import Permission from "@/helpers/permission";

export default {
  name: "ContractTemplate",
  components: {
    ContractTemplateModal,
    Pagination,
    Toolbar,
  },
  data() {
    return {
      search: '',
      selectedTemplate: null,
      templates: [],
    }
  },
  computed: {
    place() {
      return this.$store.state.auth.place;
    },
  },
  mounted() {
    this.resetPage();
    this.loadTemplates();
  },
  watch: {
    '$route.query.page'() {
      this.loadTemplates();
    },
    search() {
      this.loadTemplates();
    },
  },
  methods: {
    loadTemplates() {
      this.templates = [];
      http.get(`/places/${this.place.id_place}/contract-templates`, {
        params: {
          'page': this.$route.query.page,
          'search': this.search,
          'per_page': 10,
        }
      }).then((response) => {
        this.templates = response.data;
      });
    },
    newTemplate() {
      this.selectedTemplate = null;
      Modal.toggle('#contractTemplateModal');
    },
    editTemplate(template) {
      this.selectedTemplate = template;
      Modal.toggle('#contractTemplateModal');
    },
    deleteTemplate(template) {
      Swal.fire({
        title: 'Atenção',
        text: "Tem certeza que deseja remover este modelo de contrato?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, remover!',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: 'btn btn-secondary'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          http.delete(`/places/${this.place.id_place}/contract-templates/${template.id_contract_template}`).then(() => {
            this.loadTemplates();
            Alert.success('Modelo removido com sucesso!');
          }).catch((e) => {
            Alert.error(e.response?.data || 'Erro ao remover modelo');
          });
        }
      });
    },
    resetPage() {
      const query = {...this.$route.query, page: 1};
      this.$router.push({path: this.$route.path, query});
    },
    hasPermission(permission) {
      return Permission.has(permission);
    }
  }
}
</script>

<style scoped>

</style>



